var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-public"},[_c('content-container',[_c('card',[_c('router-view'),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('public-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }